require('./ComboboxNew');
require('./Combobox');
var Algemeen = require('./Algemeen');
var aanvraag = require('./Aanvraag');
var AanvraagAlgemeneInfo = require('./AanvraagAlgemeneInfo');
require('./AanvraagMethodes');
require('./AanvraagReports');
var Documenten = require('./Documenten');
require('./Logging');
var overzichtStalen = require('./OverzichtStalen');
require('./AanvraagAlgemeneInfo/SampleNature');
var contact = require('./AanvraagAlgemeneInfo/Contact');
var country = require('./AanvraagAlgemeneInfo/Country');
var countryOfOrigine = require('./AanvraagAlgemeneInfo/CountryOfOrigine');
var methodes = require('./AanvraagMethodes/Methodes');
require('./AanvraagStaal/ApplicationDate');
module.exports = {
    run: function () {
        aanvraag.Init();
    },
    btnNextClick: function () {
        aanvraag.btnNextClick();
    },
    btnQuickSaveClick: function () {
        aanvraag.btnQuickSaveClick();
    },
    btnBackClick: function () {
        aanvraag.btnBackClick();
    },
    btnSummaryClick: function () {
        methodes.btnSummaryClick();
    },
    btnFinishClick: function () {
        aanvraag.btnFinishClick();
    },
    checkboxMethodChanged: methodes.checkboxMethodChanged,
    Template_OnClick: AanvraagAlgemeneInfo.Template_OnClick,
    btnProductClick: methodes.btnProductClick,
    checkboxProductChanged: methodes.checkboxProductChanged,
    showPopUp: Algemeen.showPopUp,
    hidePopUp: Algemeen.hidePopUp,
    Contact_OnClick: contact.Contact_OnClick,
    ContactDelete_OnClick: contact.ContactDelete_OnClick,
    TemplateDelete_OnClick: AanvraagAlgemeneInfo.TemplateDelete_OnClick,
    showAllTemplates: aanvraag.showAllTemplates,
    onclickTdMethod: methodes.onclickTdMethod,
    onclickTdProduct: methodes.onclickTdProduct,
    triggerMethodOnchange: methodes.triggerMethodOnchange,
    triggerProductOnchange: methodes.triggerProductOnchange,
    CountryOfOrigine_OnClick: countryOfOrigine.CountryOfOrigine_OnClick,
    KeyDown: Algemeen.KeyDown,
    BtnFilterClick: overzichtStalen.BtnFilterClick,
    InitOverzichtStalen: overzichtStalen.InitOverzichtStalen
};
